export default __webpack_public_path__ + "static/media/flower-2.3dfa6df7.svg";